import groupLogo from '../../img/Group-Logo.png'

const MainBrands = () => {
  return (
    <div className="max-w-[1110px] mx-auto px-3 xs:px-6 mt-16 md:mt-20 lg:mt-24">
      <img src={groupLogo} alt="Brands" />
    </div>
  )
}

export default MainBrands
